import { render, staticRenderFns } from "./FormP10.vue?vue&type=template&id=1075bb06"
import script from "./FormP10.vue?vue&type=script&lang=ts"
export * from "./FormP10.vue?vue&type=script&lang=ts"
import style0 from "./FormP10.vue?vue&type=style&index=0&id=1075bb06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports